/*
 * Stāvoklis (condition) filter for phone collections.
 *
 * Filters .gitem[data-condition] cards on the current page (48 per page).
 * Two synced entry points: top segmented control and sidebar radio group.
 * State persists in ?condition= URL param and re-applies after filter AJAX.
 */
(function () {
  'use strict';

  var VALID = ['all', 'new', 'used'];
  var current = 'all';

  function getGrid() {
    return document.getElementById('GridContainer');
  }

  function readFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var c = params.get('condition');
      return VALID.indexOf(c) !== -1 ? c : 'all';
    } catch (e) {
      return 'all';
    }
  }

  function writeToUrl(condition) {
    try {
      var url = new URL(window.location.href);
      if (condition === 'all') {
        url.searchParams.delete('condition');
      } else {
        url.searchParams.set('condition', condition);
      }
      window.history.replaceState({}, '', url.toString());
    } catch (e) {
      /* no-op */
    }
  }

  function applyToCards(condition) {
    var grid = getGrid();
    if (!grid) return;
    var items = grid.querySelectorAll('.gitem[data-condition]');
    for (var i = 0; i < items.length; i++) {
      var cond = items[i].getAttribute('data-condition');
      var show = condition === 'all' || cond === condition;
      items[i].classList.toggle('gitem--condition-hidden', !show);
    }
  }

  function syncControls(condition) {
    // Segmented tabs
    var tabs = document.querySelectorAll('[data-condition-filter]');
    for (var i = 0; i < tabs.length; i++) {
      var active = tabs[i].getAttribute('data-condition-filter') === condition;
      tabs[i].classList.toggle('is-active', active);
      tabs[i].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
    // Sidebar radios
    var radios = document.querySelectorAll('.condition-filter-radio');
    for (var j = 0; j < radios.length; j++) {
      radios[j].checked = radios[j].value === condition;
    }
  }

  function isNewSubtype(value) {
    return String(value || '').toLowerCase().indexOf('jauns telefons') !== -1;
  }

  function isUsedSubtype(value) {
    var s = String(value || '').toLowerCase();
    return s.indexOf('mazlietots telefons') !== -1 || s.indexOf('mazlietoti telefoni') !== -1;
  }

  /* When a phone-kind subtype chip is already on, the tab must follow it
     server-side. Client-only hiding against the opposite chip yields 0 cards. */
  function alignPhoneSubtype(condition) {
    var inputs = document.querySelectorAll('#CollectionFiltersForm input.custCheck[name="filter.p.m.custom.subtype"]');
    if (!inputs.length) return false;
    var any = false;
    for (var i = 0; i < inputs.length; i++) {
      if ((isNewSubtype(inputs[i].value) || isUsedSubtype(inputs[i].value)) && inputs[i].checked) any = true;
    }
    if (!any) return false;
    var changed = false;
    for (var j = 0; j < inputs.length; j++) {
      var input = inputs[j];
      var isNew = isNewSubtype(input.value);
      var isUsed = isUsedSubtype(input.value);
      if (!isNew && !isUsed) continue;
      var want = condition === 'new' ? isNew : condition === 'used' ? isUsed : false;
      if (input.checked !== want) {
        input.checked = want;
        changed = true;
      }
    }
    return changed;
  }

  function refetchFromForm() {
    if (!window.AIOO_facets || typeof window.AIOO_facets.urlFromForm !== 'function') return;
    var url = window.AIOO_facets.urlFromForm();
    if (url) window.AIOO_facets.load(url, {});
  }

  function setCondition(condition, updateUrl) {
    if (VALID.indexOf(condition) === -1) condition = 'all';
    current = condition;
    applyToCards(condition);
    syncControls(condition);
    if (updateUrl) {
      var subtypeChanged = alignPhoneSubtype(condition);
      writeToUrl(condition);
      document.dispatchEvent(new CustomEvent('aioo:client-filter-changed'));
      if (subtypeChanged) refetchFromForm();
    }
  }

  // Delegated events — controls survive AJAX re-renders of the sidebar/grid.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-condition-filter]') : null;
    if (!btn) return;
    e.preventDefault();
    setCondition(btn.getAttribute('data-condition-filter'), true);
  });

  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (!radio || !radio.classList || !radio.classList.contains('condition-filter-radio')) return;
    setCondition(radio.value, true);
  });

  // Re-apply the active condition whenever the native filter AJAX swaps the grid.
  function observeGrid() {
    var grid = getGrid();
    if (!grid || !window.MutationObserver) return;
    var obs = new MutationObserver(function () {
      var next = readFromUrl();
      if (next !== current) {
        setCondition(next, false);
      } else if (current !== 'all') {
        applyToCards(current);
        syncControls(current);
      }
    });
    obs.observe(grid, { childList: true });
  }

  function init() {
    setCondition(readFromUrl(), false);
    observeGrid();
    document.addEventListener('aioo:collection-filters-updated', function () {
      setCondition(readFromUrl(), false);
    });
  }

  // Exposed for collection-phone-model-nav.js: clicking a specific model pill
  // should always reveal that card even if a Jauni/Mazlietoti tab currently hides it.
  window.AIOO_resetConditionFilter = function () {
    setCondition('all', true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
